import React from "react";
import "./style.css";
import { useNavigate } from "react-router";
import { getDelawareDate } from "../env";

export default function Course({ img, name,courseId,onclick }) {
    return (
        <div
            onClick={onclick}
            className="course_container"
            style={{
                backgroundImage: `linear-gradient(0deg, rgba(53,62,73,1) 0%, rgba(53,62,73,0.6980042016806722) 46%, rgba(53,62,73,0) 100%), url(${img})`,
            }}
        >
            <p>{name}</p>
        </div>
    );
}
